import {
  Box,
  Flex,
  Spinner,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React from 'react';

const Loading = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const FlexItem = (props: any) => (
    <Box display="inline" verticalAlign="middle" fontSize="14px" {...props} />
  );
  return (
    <>
      <Flex
        flexDirection="column"
        bg={colorStyle.background.primary}
        height="100vh"
        alignItems="center"
      >
        <FlexItem flex="auto">{}</FlexItem>
        <FlexItem flex="auto" p="50vh 0">
          <Spinner />
        </FlexItem>
        <FlexItem flex="auto">{}</FlexItem>
      </Flex>
    </>
  );
};
export default Loading;
